var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1425_15263)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.96875 8.00014C0.96875 7.86753 1.01343 7.74036 1.09296 7.64659C1.17249 7.55282 1.28036 7.50014 1.39283 7.50014H11.3953L8.72609 4.35414C8.64646 4.26026 8.60172 4.13292 8.60172 4.00014C8.60172 3.86737 8.64646 3.74003 8.72609 3.64614C8.80572 3.55226 8.91372 3.49951 9.02634 3.49951C9.13896 3.49951 9.24696 3.55226 9.32659 3.64614L12.7193 7.64614C12.7588 7.69259 12.7901 7.74776 12.8115 7.80851C12.8328 7.86926 12.8439 7.93438 12.8439 8.00014C12.8439 8.06591 12.8328 8.13103 12.8115 8.19178C12.7901 8.25252 12.7588 8.3077 12.7193 8.35414L9.32659 12.3541C9.24696 12.448 9.13896 12.5008 9.02634 12.5008C8.91372 12.5008 8.80572 12.448 8.72609 12.3541C8.64646 12.2603 8.60172 12.1329 8.60172 12.0001C8.60172 11.8674 8.64646 11.74 8.72609 11.6461L11.3953 8.50014H1.39283C1.28036 8.50014 1.17249 8.44746 1.09296 8.3537C1.01343 8.25993 0.96875 8.13275 0.96875 8.00014Z",
    fill: "#9097A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1425_15263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5707,
    height: 16,
    fill: "white",
    transform: "translate(0.121094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateArrowRight);
export default __webpack_public_path__ + "static/media/date-arrow-right.2bf77c5587f8fe5edf39c938d2f0f25e.svg";
export { ForwardRef as ReactComponent };